import { render, staticRenderFns } from "./OrderStatis.vue?vue&type=template&id=3c93a1ed&scoped=true&"
import script from "./OrderStatis.vue?vue&type=script&lang=js&"
export * from "./OrderStatis.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatis.vue?vue&type=style&index=0&id=3c93a1ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c93a1ed",
  null
  
)

export default component.exports